// Direction the fur leans at each skin vertex, as a tangent vector of length
// up to 1. Stroking combs it along the hand; it then relaxes very slowly back
// to a natural droop, so a petting trail stays visible for a while.
export class FurComb{
  constructor({rest,normals}){
    this.rest=rest;this.normals=normals;const n=rest.length/3;
    this.droop=new Float32Array(n*3);this.comb=new Float32Array(n*3);
    for(let i=0;i<n;i++){
      const t=this.tangent(i,[0,-.35,0]);this.droop.set(t,i*3);this.comb.set(t,i*3);
    }
    this.changed=true;
  }
  tangent(i,v){
    const n=this.normals,d=v[0]*n[i*3]+v[1]*n[i*3+1]+v[2]*n[i*3+2];
    return [v[0]-d*n[i*3],v[1]-d*n[i*3+1],v[2]-d*n[i*3+2]];
  }
  nearest(point){
    let best=0,bestD=Infinity;const p=this.rest;
    for(let i=0;i<p.length/3;i++){const d=(p[i*3]-point[0])**2+(p[i*3+1]-point[1])**2+(p[i*3+2]-point[2])**2;if(d<bestD){bestD=d;best=i;}}
    return best;
  }
  brush(point,motion,radius){
    const p=this.rest,c=this.comb,r2=radius*radius;
    for(let i=0;i<p.length/3;i++){
      const d2=(p[i*3]-point[0])**2+(p[i*3+1]-point[1])**2+(p[i*3+2]-point[2])**2;if(d2>=r2)continue;
      const w=Math.exp(-d2/(r2*.4))*14,t=this.tangent(i,motion);
      for(let a=0;a<3;a++)c[i*3+a]+=t[a]*w;
      // Keep it tangent and no longer than 1.
      const fixed=this.tangent(i,[c[i*3],c[i*3+1],c[i*3+2]]),length=Math.hypot(...fixed),s=length>.9999?.9999/length:1;
      for(let a=0;a<3;a++)c[i*3+a]=fixed[a]*s;
    }
    this.changed=true;
  }
  relax(dt){
    const k=1-Math.exp(-dt/30);
    for(let i=0;i<this.comb.length;i++)this.comb[i]+=(this.droop[i]-this.comb[i])*k;
    this.changed=true;
  }
}
